<!-- ════ HERO SOBRE NÓS ════ -->
<header class="about-hero">
  <div class="about-hero-inner">
    <div class="about-hero-eyebrow">
      <i class="fas fa-cube"></i>
      A nossa história
    </div>
    <h1 class="about-hero-title">
      Democratizando o acesso<br />
      ao capital em <em>Angola</em>
    </h1>
    <p class="about-hero-desc">
      {{ sobre || 'Somos a maior plataforma de crowdfunding angolana — uma ponte entre ideias transformadoras e as
      comunidades que acreditam nelas.' }}
    </p>
    <div class="about-hero-cta">
      <a routerLink="/criar-campanha" class="btn-hero-primary">
        <i class="fas fa-rocket"></i> Iniciar Campanha
      </a>
      <button type="button" (click)="scrollTo('pilares')" class="btn-hero-ghost">
        <i class="fas fa-arrow-down"></i> Conhecer os Pilares
      </button>
    </div>
  </div>
  <div class="about-hero-wave">
    <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
      <path d="M0,40 C360,80 1080,0 1440,40 L1440,60 L0,60 Z" fill="#ffffff" />
    </svg>
  </div>
</header>

<!-- ════ STATS SECTION ════ -->
<div class="stats-section">
  <div class="container">
    <div class="stats-inner">
      <div class="stat-item">
        <div class="stat-icon green">
          <i class="fas fa-calendar-check"></i>
        </div>
        <div class="stat-number">
          <span>2024</span>
        </div>
        <div class="stat-label">Ano de Fundação</div>
        <div class="stat-sublabel">Nascida em Angola</div>
      </div>

      <div class="stat-item">
        <div class="stat-icon amber">
          <i class="fas fa-bullhorn"></i>
        </div>
        <div class="stat-number">
          <span>{{ stats.totalCampanhas || 0 }}</span>
          <span class="plus">+</span>
        </div>
        <div class="stat-label">Campanhas Realizadas</div>
        <div class="stat-sublabel">Em todas as províncias</div>
      </div>

      <div class="stat-item">
        <div class="stat-icon blue">
          <i class="fas fa-users"></i>
        </div>
        <div class="stat-number">
          <span>{{ stats.totalUtilizadores || InformacoeSobre?.totalUtilizador || 0 }}</span>
          <span class="plus">+</span>
        </div>
        <div class="stat-label">Utilizadores Registados</div>
        <div class="stat-sublabel">Apoiantes e criadores</div>
      </div>

      <div class="stat-item">
        <div class="stat-icon purple">
          <i class="fas fa-hand-holding-usd"></i>
        </div>
        <div class="stat-number">
          <span>{{ (stats.totalApoios || InformacoeSobre?.totalFinanciamento || 0) | money }}</span>
          <span class="currency"> Kz</span>
        </div>
        <div class="stat-label">Total Financiado</div>
        <div class="stat-sublabel">Transformados em impacto</div>
      </div>
    </div>
  </div>
</div>

<!-- ════ PILARES: MISSÃO, VISÃO & VALORES ════ -->
<section class="section section-pilares" id="pilares">
  <div id="valores" style="position: relative; top: -80px;"></div>
  <div class="container">
    <div class="section-header centered">
      <div class="section-eyebrow">Os Nossos Pilares</div>
      <h2 class="section-title">Missão, Visão e <em>Valores</em></h2>
      <p class="section-desc">
        Os princípios que guiam cada decisão e inspiram cada campanha na nossa plataforma.
      </p>
    </div>

    <div class="mvv-grid">
      <!-- Missão -->
      <article class="mvv-card mvv-missao">
        <div class="mvv-icon-wrap">
          <i class="fas fa-bullseye"></i>
        </div>
        <div class="mvv-label">Missão</div>
        <h3 class="mvv-heading">O nosso propósito</h3>
        <p class="mvv-text">
          {{ missao || 'Desejamos ser o motor da nossa comunidade, apoiando mudanças significativas. O nosso compromisso
          é democratizar o acesso ao capital, abrindo portas para projectos inovadores com impacto social profundo,
          duradouro e positivo.' }}
        </p>
      </article>

      <!-- Visão -->
      <article class="mvv-card mvv-visao">
        <div class="mvv-icon-wrap">
          <i class="fas fa-eye"></i>
        </div>
        <div class="mvv-label">Visão</div>
        <h3 class="mvv-heading">O futuro que imaginamos</h3>
        <p class="mvv-text">
          {{ visao || 'Imaginamos um mundo onde toda ideia, por mais ousada que seja, tenha a oportunidade de se tornar
          realidade, criando uma rede sólida de apoiadores e visionários.' }}
        </p>
      </article>

      <!-- Valores -->
      <article class="mvv-card mvv-valores">
        <div class="mvv-icon-wrap">
          <i class="fas fa-gem"></i>
        </div>
        <div class="mvv-label">Valores</div>
        <h3 class="mvv-heading">O que nos define</h3>
        <p class="mvv-text">
          {{ valores || 'Valorizamos a Transparência, a Inovação, a Sustentabilidade e o Rigor em todas as nossas
          iniciativas, construindo uma comunidade sólida e confiável.' }}
        </p>
        <div class="mvv-tags">
          <span class="mvv-tag"><i class="fas fa-search"></i> Transparência</span>
          <span class="mvv-tag"><i class="fas fa-lightbulb"></i> Inovação</span>
          <span class="mvv-tag"><i class="fas fa-leaf"></i> Sustentabilidade</span>
          <span class="mvv-tag"><i class="fas fa-scale-balanced"></i> Rigor</span>
        </div>
      </article>
    </div>
  </div>
</section>

<!-- ════ EQUIPA: IMAGEM & DADOS ════ -->
<section class="section section-alt" id="equipa">
  <div class="container">
    <div class="team-layout">
      <!-- Imagem Equipa -->
      <div class="team-img-wrap">
        <img src="images/time.jpeg" alt="Equipa FundCube Angola em reunião de trabalho" loading="lazy"
          onerror="this.src='/images/campanha-1.png'" />
        <div class="team-img-overlay"></div>
        <div class="team-img-badge">
          <i class="fas fa-award"></i> Equipa FundCube
        </div>
        <div class="team-img-caption">
          <div class="team-img-caption-title">Nossa Equipa</div>
          <div class="team-img-caption-sub">Luanda, Angola · Construindo o futuro</div>
        </div>
      </div>

      <!-- Texto e Métricas -->
      <div class="team-text-content">
        <div class="section-eyebrow">Quem Somos</div>
        <h2 class="section-title">Pessoas apaixonadas por <em>impacto</em></h2>
        <p class="section-desc">
          Somos um grupo multidisciplinar de profissionais comprometidos em desenvolver soluções digitais acessíveis,
          seguras e transparentes para financiar o desenvolvimento socioeconómico de Angola.
        </p>
        <p class="team-extra-text">
          A equipa FundCube combina experiência em finanças, engenharia de software e envolvimento comunitário para
          aproximar sonhadores de investidores e apoiadores em todo o território nacional.
        </p>

        <div class="team-stat-row">
          <div class="team-stat-box">
            <div class="team-stat-val">18</div>
            <div class="team-stat-lbl">Províncias no radar</div>
          </div>
          <div class="team-stat-box">
            <div class="team-stat-val">100%</div>
            <div class="team-stat-lbl">Conformidade bancária</div>
          </div>
          <div class="team-stat-box">
            <div class="team-stat-val">24/7</div>
            <div class="team-stat-lbl">Acompanhamento e suporte</div>
          </div>
          <div class="team-stat-box">
            <div class="team-stat-val">99%</div>
            <div class="team-stat-lbl">Índice de transparência</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ════ COMO FUNCIONA O PROCESSO ════ -->
<section class="section section-processo">
  <div class="container">
    <div class="section-header centered">
      <div class="section-eyebrow">Etapas Claras</div>
      <h2 class="section-title">Como a FundCube <em>Funciona</em></h2>
      <p class="section-desc">
        Na FundCube, você conecta sua ideia a milhares de pessoas dispostas a apoiar.
      </p>
    </div>

    <div class="process-steps-grid">
      <div class="step-card">
        <div class="step-card-num">01</div>
        <div class="step-card-icon green">
          <i class="fas fa-lightbulb"></i>
        </div>
        <h3 class="step-card-title">Apresenta a Ideia</h3>
        <p class="step-card-desc">
          Um criador regista o seu projecto, detalha as metas e publica a história na plataforma.
        </p>
      </div>

      <div class="step-card">
        <div class="step-card-num">02</div>
        <div class="step-card-icon amber">
          <i class="fas fa-hand-holding-heart"></i>
        </div>
        <h3 class="step-card-title">Contribuição Segura</h3>
        <p class="step-card-desc">
          Apoiadores financiam através de múltiplos métodos de pagamento locais com confirmação imediata.
        </p>
      </div>

      <div class="step-card">
        <div class="step-card-num">03</div>
        <div class="step-card-icon blue">
          <i class="fas fa-bullseye"></i>
        </div>
        <h3 class="step-card-title">Atinge a Meta</h3>
        <p class="step-card-desc">
          Quando o valor necessário é alcançado, o criador recebe os fundos para dar início à execução.
        </p>
      </div>

      <div class="step-card">
        <div class="step-card-num">04</div>
        <div class="step-card-icon purple">
          <i class="fas fa-earth-africa"></i>
        </div>
        <h3 class="step-card-title">Gera Impacto</h3>
        <p class="step-card-desc">
          O projecto ganha vida, transforma realidades e reporta os avanços a toda a comunidade.
        </p>
      </div>
    </div>
  </div>
</section>

<!-- ════ CTA SOBRE NÓS ════ -->
<section class="section-cta-sobre">
  <div class="container">
    <div class="cta-inner-sobre">
      <h2 class="cta-title-sobre">Tem um projecto que merece sair do papel?</h2>
      <p class="cta-desc-sobre">
        Publique hoje a sua campanha na FundCube e conte com a força de milhares de apoiadores angolanos.
      </p>
      <div class="cta-btns-sobre">
        <a routerLink="/criar-campanha" class="btn btn-amber btn-xl btn-rounded">
          <i class="fas fa-rocket"></i> Criar Campanha Agora
        </a>
        <a routerLink="/campanhas" class="btn btn-white btn-xl btn-rounded">
          <i class="fas fa-compass"></i> Explorar Projectos
        </a>
      </div>
    </div>
  </div>
</section>

<!-- ════ PARTNERS & NEWSLETTER ════ -->
<app-partners />
<app-newsletter />